import React from "react";
import Big from "big.js";
import { IconButton } from "@mui/material";
import { SSvgIcon, SGrid } from "./styles";
import { ReactComponent as IconUnbalanced } from "../../../../assets/balancingIconUnbalanced.svg";
import { ReactComponent as IconBalanced } from "../../../../assets/balancingIconBalanced.svg";
import { useCurrentPortfolio } from "../../../../store";

export const BalancingButton: React.FC = () => {
  const { balanceCurrentPortfolio, portfolioAssets } = useCurrentPortfolio();

  const assestPercentages = Object.keys(portfolioAssets).map((assetKey) =>
    Big(portfolioAssets[assetKey].percentage || 0).toNumber()
  );
  const isEquallyDivided = (value: number): boolean =>
    assestPercentages.length === 0
      ? false
      : value === Big(100).div(assestPercentages.length).toNumber();
  const isBalanced = assestPercentages.every(isEquallyDivided);

  const handleBalance = (): void => {
    if (!isBalanced) balanceCurrentPortfolio();
  };

  return (
    <SGrid>
      <IconButton onClick={handleBalance} disableRipple disabled={isBalanced}>
        <SSvgIcon $isBalanced={isBalanced} inheritViewBox>
          <IconBalanced />
          {isBalanced ? <IconBalanced /> : <IconUnbalanced />}
        </SSvgIcon>
      </IconButton>
    </SGrid>
  );
};
